import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  name: 'toggleButton',
  props: ['isHidden']
})
export default class ToggleButton extends Vue {
  get action () {
    return this.$props['isHidden'] ? 'show' : 'hide'
  }

  get type () {
    return 'fas'
  }

  get icon () {
    return this.$props['isHidden'] ? 'caret-right' : 'caret-down'
  }
}
